export default __webpack_public_path__ + "static/media/phone.af06259c.svg";